<template>
    <div class="employee-tab-inner">        
        <!--<ul class="list-group mb-3 " v-if='errormsg'>           
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->     
        <b-overlay :show="showoverlay" rounded="sm">
             <div class="gf-reporting-tab payroll-reporting-tab trz_gf_loan_tab" id="nav-tabContent-intro4">
                <b-tabs content-class="mt-3 reports-tab-wrapper" nav-wrapper-class="mb-2 mt-2 reports-tab-nav-wrapper">
                                    
                        <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                        <b-tab active>

                            <template #title>
                                <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/public/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/public/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>View Application(s)
                                </div>
                                <div class="report-intro">
                                    Process loan applications
                                </div>
                                <b-button class="mt-3">View</b-button>
                            </template>
                             <div class="">
                            <div class="col-12 text-right pr-0"><b-button  class="mb-1 w-100" @click="addNew()" style="max-width: 325px;">Add Loan</b-button></div>
                            <gf-loan-applications :pageurl="this.$api_url"  :key="this.init_flg" :flg="this.init_flg" ></gf-loan-applications>
                            </div>
                        </b-tab>
                        <b-tab lazy>

                             <template #title>
                                <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/public/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/public/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/> Process Loan
                                </div>
                                <div class="report-intro">
                                    Process new loan for employee
                                </div>
                                <b-button class="mt-3">View</b-button>
                            </template>
                                <div class="">
                                    <div class="col-12 text-right pr-0"><b-button  class="mb-1 w-100" @click="addNew()" style="max-width: 325px;">Add Loan</b-button></div>
                                
                                    <div class="">
                                        <div v-if="custom_list.length>0">
                                            <common-list  :pageurl="this.$api_url"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" is_pf="1" v-on:childToParent="listReturn"></common-list>
                                        </div>
                                        <div v-else>
                                            <div v-if="show_loader" class="list-no-data">
                                                <span class="d-block text-center">Looking for relevant data..</span>
                                                <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                            </div>
                                            <div v-else class="list-no-data">
                                                Looks like there is no employee to show.
                                            </div>
                                        </div>
                                    </div>   
                                </div>      
                            
                    
                        </b-tab> 
                        
                        <b-tab lazy>
                            <template #title>
                                <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/public/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/public/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>Employee Loan Profile
                                </div>
                                <div class="report-intro">
                                    Employee loan profile show individual employee's loan history
                                </div>
                                <b-button class="mt-3">View</b-button>
                            </template>
                            <div class="">
                                <gf-loan-profile-list :pageurl="this.$api_url"  :key="this.init_flg" ></gf-loan-profile-list>
                            </div>
                        </b-tab>                        


                    <!-- Form ends here -->
                </b-tabs>
            </div>
        </b-overlay>
    
    
    
    <b-modal id="bv-modal-process-loan" size="lg" hide-footer v-bind:title="modal_title">
            <gf-loan-form :pageurl="this.$api_url" :flg="this.init_flg" :employee_id="curr_process_id" v-on:childToParent="updateTransactions" :employee_name="curr_process_name" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status"></gf-loan-form>                  
    </b-modal>
    <b-modal id="bv-modal-employee" size="lg" hide-footer v-bind:title="modal_title">
            <search-employee-gf :pageurl="this.$api_url" v-on:childToParent="setEmployee"></search-employee-gf>
    </b-modal> 
    
    
    </div>
    
    
    
    
</template>
 
<script>
    
    import myUpload from 'vue-image-crop-upload';
    import moment from 'moment';
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],
        components: {
           'my-upload': myUpload,
        },
        data(){            
            
            return {
                loans:[], 
                loan_id:'',
                is_custom:'',
                is_status:'',   
                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,
                show_loader : true,
                errormsg:[],
                
                fdata: {
                            
                        },

                xdata : {
                    
                },
                pgurl:this.$api_url,
                new_capability:true,
                
                /* new variables*/
                emp_list_data : [], 
                application_lists: [],
                people:0,
                search:'',
                length: 10,
                length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },{ value: 30, text: "30" },{ value: 40, text: "40" },{ value: 50, text: "50" }],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1}, 
                curr_process_id: 0,
                curr_process_name: '',
                count:'', 
                modal_title:'',
                init_flg : 0,
                /**Child Component property data */
                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','email','jobposition','department'], /* Default Column List */
                appended_column:[],                   /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },
            addNew: function()
            {
                this.$bvModal.show('bv-modal-employee');
            },
            updateTransactions(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/gf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-process-loan');
                    this.init_flg = this.init_flg + 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            setEmployee: function(data)
            {
                this.curr_process_name = data['name'];
                this.curr_process_id = data['id'];
                this.modal_title = "Process GF Loan";
                //alert(emp_name);
                if(this.curr_process_name.length >0)
                this.modal_title += " for "+this.curr_process_name;
        
                this.count = this.count + 1;
                this.$bvModal.hide('bv-modal-employee');
                this.$bvModal.show('bv-modal-process-loan');
            },
            maxStartDate: function() {
                return moment()
                    .startOf('month')
                    .add(1, 'months')
                    .endOf('month').format('DD/MM/YYYY');
            },
            showMessage: function()
            {
                let childdata = {employee_id:this.fdata.employee_id , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg};                    
                this.$emit('childToParent', childdata);
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {                    
                };

                this.reset_flg = true;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            processLoan(emp_id,emp_name)
            {
                this.modal_title = "Process GF Loan";
                if(emp_name.length >0)
                this.modal_title += " for "+emp_name;
                
                this.curr_process_id = emp_id;
                this.curr_process_name = emp_name;
                this.$bvModal.show('bv-modal-process-loan');
            },
            listReturn:function(data)
            {

                if(data.employee_id && data.action_id==1)
                {
                    this.processLoan(this.custom_array[data.employee_id].employee_id,this.custom_array[data.employee_id].name);
                }
                

            },
            getGfEmployeeListData: function(){
            let currentObj = this;
            this.showoverlay = true;
            this.show_loader = true;
              axios.get(this.$api_url+'/gf/employee/list', {
                    })
              .then(function (response) {
                 this.showoverlay = false;
                 
                    /* Assingning the Options */ 

                    this.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */ 
                    this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    
                    if(this.tmp_custom_list.length > 0 )
                    {
                        this.tmp_custom_list.forEach(element => {
                                if(element.employee_id > 0)
                                {

                                    this.custom_array[element.employee_id] = element;
                                    let dop = []; 
                                    /*  If DropDown type one is First Choice */
                                    
                                        dop = dop.concat([{ label: 'Process Loan' , value: 1 }]);
                                    
                                    /* Action for all column **/

                                    element.actions = dop;
                                }
                            });
                        
                    }
                    
                    this.custom_list = this.tmp_custom_list;
                    this.show_loader = false;

                    console.log(this.custom_list);
                    this.list_key = this.list_key + 1;
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
         
            },
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.getGfEmployeeListData();
            this.updateTransactions(1);
        }
    }
</script>
